/* Colette & Co. — finish preference runtime.
 *
 * One selection, session-wide, two controls (the rail and the PDP swatch
 * block) that must always agree — the bounded-region rule: they read as one
 * system in two places.
 *
 * State lives in sessionStorage under `colette:finish`. A tiny inline
 * bootstrap in theme.liquid applies the stored value to <html> before first
 * paint so there is no flash of the default; this file wires the controls
 * and does the live repaint.
 *
 * Repaint surface, deliberately honest: CSS variables, [data-fin] SVG
 * accents, finish-name text nodes, and links that carry data-colette-link.
 * Real product photography does not repaint — pretending it does is exactly
 * the kind of storefront dishonesty the master prompt bans. What changes is
 * the frame around the product, and the links route to the finish that was
 * chosen.
 */
(function () {
  'use strict';

  var FINISHES = {
    'aged-brass':      { hex: '#A98A4F', name: 'Aged Brass' },
    'blackened-steel': { hex: '#33322E', name: 'Blackened Steel' },
    'raw-bronze':      { hex: '#6E4C2F', name: 'Raw Bronze' },
    'smoked-nickel':   { hex: '#8E8F8B', name: 'Smoked Nickel' },
    'chalk-white':     { hex: '#DAD5C8', name: 'Chalk White' },
    'verdigris-green': { hex: '#5F7161', name: 'Verdigris Green' },
    'natural-wood':    { hex: '#8B6B4A', name: 'Natural Wood' }
  };
  var DEFAULT = 'aged-brass';
  var KEY = 'colette:finish';

  function stored() {
    try {
      var v = sessionStorage.getItem(KEY);
      return FINISHES[v] ? v : DEFAULT;
    } catch (e) { return DEFAULT; }
  }

  function apply(handle) {
    var finish = FINISHES[handle] || FINISHES[DEFAULT];
    var root = document.documentElement;

    root.setAttribute('data-colette-finish', handle);
    root.style.setProperty('--finish-hex', finish.hex);

    // Every [data-fin] element takes the finish colour (CSS handles the
    // transition); inline style covers SVGs whose colour was authored inline.
    document.querySelectorAll('[data-fin]').forEach(function (el) {
      el.style.color = finish.hex;
    });

    // Text nodes that display the selected finish name.
    document.querySelectorAll('[data-colette-finish-name]').forEach(function (el) {
      el.textContent = finish.name;
    });

    // Links that should route to the selected finish's landing page.
    document.querySelectorAll('[data-colette-link="finish"]').forEach(function (el) {
      el.setAttribute('href', '/collections/' + handle);
    });

    // Both control groups mirror the same state.
    document.querySelectorAll('[data-colette-finish-option]').forEach(function (btn) {
      var pressed = btn.getAttribute('data-colette-finish-option') === handle;
      btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    });
  }

  function select(handle) {
    if (!FINISHES[handle]) return;
    try { sessionStorage.setItem(KEY, handle); } catch (e) { /* private mode */ }
    apply(handle);
    document.dispatchEvent(new CustomEvent('colette:finish', { detail: { finish: handle } }));
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-colette-finish-option]');
    if (!btn) return;
    // A PDP swatch for a finish this product exists in navigates to that
    // variant product; a plain chip just sets the preference.
    var href = btn.getAttribute('data-colette-href');
    select(btn.getAttribute('data-colette-finish-option'));
    if (href) window.location.href = href;
  });

  // Sections re-rendered by the theme editor need re-wiring.
  document.addEventListener('shopify:section:load', function () { apply(stored()); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(stored()); });
  } else {
    apply(stored());
  }
})();
